export default "__VITE_ASSET__DNPg2ti9__"